{
  "primer": {
    "eyebrow": "Waktu salat dan Kiblat",
    "headline": "Rhemn memerlukan lokasi Anda untuk waktu salat dan arah Kiblat.",
    "body": "Kami memakainya untuk waktu salat, arah Kiblat, dan cuaca setempat Anda — tidak untuk hal lain.",
    "cta": "Lanjutkan",
    "skip": "Nanti saja",
    "skip_body": "Waktu salat dan arah Kiblat akan tetap nonaktif."
  }
}
